import { API_BASE_URL } from "./config";
import { BrowserRouter, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import Login from './Source/Login/login';
import Home from './Source/Home/home';
import DashBoard from './Source/DashBoard/dashBoard';
import './App.css';
import { useEffect, useState } from 'react';
import UserManagement from "./Source/Management/UserManage/UserManagement";
import EditUser from "./Source/Management/UserManage/EditUser";
import ItemTypeManagement from "./Source/Management/ItemManage/ItemTypeManagement";
import CreateItemType from "./Source/Management/ItemManage/CreateItemType";
import SalePriceListManagement from "./Source/Management/SalePriceManage/SalePriceListManagement";
import SalePriceListCreate from "./Source/Management/SalePriceManage/SalePriceListCreate";
import SalePriceAndItemManage from "./Source/Management/SalePriceAndItemManage/SalePriceAndItemManage";
import UserRegister from "./Source/Management/UserManage/UserRegister";
import CustomerDataManagement from "./Source/Management/CustomerDataManager/CustomerDataManagement";
import SaleReportManagement from "./Source/Management/SaleReportManager/SaleReportManagement";
import UserDataRegister from "./Source/Management/UserManage/UserDataRegister";
import EditCustomerData from "./Source/Management/CustomerDataManager/EditCustomerData";
import CustomerDetail from "./Source/Management/CustomerDataManager/CustomerDetail";
import EditItemType from "./Source/Management/ItemManage/EditItemType";
import EditSalePriceList from "./Source/Management/SalePriceManage/EditSalePriceList";
import CreateSubProductItem from "./Source/Management/ItemManage/CreateSubProductItem";
import EditSubProductItem from "./Source/Management/ItemManage/EditSubProductItem";
import SaleReportDetail from "./Source/Management/SaleReportManager/SaleReportDetail";
import AgentSaleDataDetail from "./Source/Management/SaleReportManager/AgentSaleDataDetail";
import SellerAssignManager from "./Source/Management/SellerAssignManager/SellerAssignManager";
import DashMap from "./Source/DashBoard/DashMap";
import ProfilePictureUpload from "./Source/TestFunction/ProfilePictureUpload";
import "./Source/Css/USaleNode.css"
import "./Source/Css/base.css"
import Develop_Feature from "./Source/DashBoard/MapNavigate";
import MapTrack from "./Source/DashBoard/MapTrack";
import AgentManagement from "./Source/Management/AgentManage/AgentManagement";
import AgentSaleFactory from "./Source/Management/SaleManage/AgentSaleFactory";
import DebtManagement from "./Source/Management/SaleReportManager/DebtManagement";
import CreditCustomers from "./Source/Management/SaleReportManager/CreditCustomers";
import AccountingDailyReport from "./Source/Management/AccountingReport/AccountingDailyReport";
import BagCredit from "./Source/Management/BagCredit/BagCredit";
import DriverDailyReport from "./Source/Management/SaleReportManager/DriverDailyReport";
import CargoRegistrationAdmin from "./Source/Management/SaleReportManager/CargoRegistrationAdmin";
import BagLedgerAccounting from "./Source/Management/SaleReportManager/BagLedgerAccounting";
import DriverAssignmentList from "./Source/Management/SaleReportManager/DriverAssignmentList";

import AlertSystem from "./Source/Dev/AlertSystem";
import DeliveryMaster from "./Source/Dev/DeliveryMaster";
import DeliverySchedule from "./Source/Dev/DeliverySchedule";
import LoadCellManager from "./Source/Dev/LoadCellManager";
import HardWare from "./Source/Dev/HardWare";
import ScadaPage from "./Source/Dev/ScadaPage";
import DdsAdmin from "./Source/Dev/DdsAdmin";
import TabletTokenAdmin from "./Source/Dev/TabletTokenAdmin";
import ImdRemoteControl from "./Source/Dev/ImdRemoteControl/ImdRemoteControl";
import ImdDeviceDetail from "./Source/Dev/ImdRemoteControl/ImdDeviceDetail";
import PaymentCodeAdmin from "./Source/Dev/PaymentCodeAdmin";
import ShiftAdmin from "./Source/Dev/ShiftAdmin";
import LEGACY_REDIRECTS from "./legacyRedirects";
import TaxInvoiceBulk from "./Source/Dev/TaxInvoiceBulk";
import PermissionAdmin from "./Source/Dev/PermissionAdmin";
import CctvViewer from "./Source/Dev/CctvViewer";
import RoutineCustomers from "./Source/Management/CustomerDataManager/RoutineCustomers";
import CustomerPurchaseBehavior from "./Source/Management/CustomerDataManager/CustomerPurchaseBehavior";
import { hasPermissionRecovery, reportPermissionDenied, restorePermissionSession } from "./Source/Utils/permissionNotice";
import TankManagement from "./Source/Management/CustomerDataManager/TankManagement";
import TankRequestManagement from "./Source/Management/CustomerDataManager/TankRequestManagement";

// redirect หน้าที่เอาออก โดยเก็บ query เดิม (เช่น ?date=) ไว้
const RedirectKeepSearch = ({ to }) => {
    const { search } = useLocation();
    return <Navigate to={`${to}${search}`} replace />;
};

function LoginRoute(props) {
    useLocation();
    return localStorage.getItem("user") || hasPermissionRecovery()
        ? <Navigate to="/" replace />
        : <Login {...props} />;
}

function App() {
    const [loggedIn, setLoggedIn] = useState(true);
    const [username, setUsername] = useState("");
    const [token, setToken] = useState("");
    const [role, setRole] = useState("");

    useEffect(() => {
        // Fetch the user details from localStorage
        restorePermissionSession();
        const user = JSON.parse(localStorage.getItem("user"));

        if (user && user.token) {
            // User is already logged in across tabs
            setLoggedIn(true);
            setUsername(user.username || "");
            setToken(user.token || "");
            setRole(user.roles || "");
        } else {
            // User is not logged in
            setLoggedIn(false);
        }

        // Verify token and refresh permissions on app load
        const verifyAndRefresh = async () => {
            if (!user || !user.token) return;
            try {
                const resp = await fetch(`${API_BASE_URL}/auth/api/main/user`, {
                    method: "GET",
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + user.token
                    },
                });
                if (resp.status === 401) {
                    // A 401 means the token itself is not valid anymore.  A 403 is
                    // an authorization decision and must keep the user signed in.
                    localStorage.removeItem("user");
                    setLoggedIn(false);
                    return;
                }
                if (resp.status === 403) {
                    void reportPermissionDenied(resp, `${API_BASE_URL}/auth/api/main/user`);
                    return;
                }
                if (resp.ok) {
                    const userData = await resp.json();
                    const updated = { ...user, permissions: userData.permissions || [] };
                    localStorage.setItem("user", JSON.stringify(updated));
                }
            } catch (e) {
                console.error('Auth verify error', e);
            }
        };
        verifyAndRefresh();
    }, []);

    useEffect(() => {
        const originalFetch = window.fetch.bind(window);
        window.fetch = async (...args) => {
            const response = await originalFetch(...args);
            if (response.status === 403) {
                void reportPermissionDenied(response, args[0]);
            }
            return response;
        };
        return () => { window.fetch = originalFetch; };
    }, []);

    // Sync localStorage changes across tabs
    useEffect(() => {
        const handleStorageChange = () => {
            const user = JSON.parse(localStorage.getItem("user"));

            if (user && user.token) {
                setLoggedIn(true);
                setUsername(user.username || "");
                setToken(user.token || "");
                setRole(user.roles || "");
            } else {
                setLoggedIn(false);
            }
        };

        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/login" element={<LoginRoute setLoggedIn={setLoggedIn} setUsername={setUsername} setToken={setToken} />} />
                    <Route path="/" element={loggedIn ? <Home /> : <Navigate to="/login" />} >
                        <Route path="DashBoard" element={<DashBoard />} />
                        <Route path="MapTrack" element={<MapTrack />} />
                        <Route path="Develop_Feature" element={<Develop_Feature />} />
                        <Route path="DashMap" element={<DashMap />} />
                        <Route path="user-management" element={<UserManagement />} />
                        <Route path="agent-management" element={<AgentManagement />} />
                        <Route path="agent-sale-factory" element={<AgentSaleFactory />} />
                        <Route path="/user-Edit/:username" element={<EditUser />} />
                        <Route path="edit/:id" element={<EditUser />} />
                        <Route path="salepriceAndItemManage" element={<SalePriceAndItemManage/>} />
                        <Route path="item/create" element={<CreateItemType />} />
                        <Route path="/item/edit/:id" element={<EditItemType/>} />
                        <Route path="sub-item/create" element={<CreateSubProductItem />} />
                        <Route path="/sub-item/edit/:id" element={<EditSubProductItem/>} />
                        <Route path="salePriceList/create" element={<SalePriceListCreate/>} />
                        <Route path="/salePriceList/user/:id" element={<EditSalePriceList/>} />
                        <Route path="/register" element={<UserRegister />} />
                        <Route path="customerData" element={<CustomerDataManagement/>} />
                        <Route path="tank-management" element={<TankManagement/>} />
                        <Route path="tank-requests" element={<TankRequestManagement/>} />
                        <Route path="/CustomerData/edit/:id" element={<EditCustomerData/>} />
                        <Route path="/customerDetail/:type/:id" element={<CustomerDetail />} />
                        <Route path="LineManager" element={<SellerAssignManager/>} />
                        <Route path="SaleData-management" element={<SaleReportManagement/>} />
                        <Route path="/saleDataDetail/:id" element={<SaleReportDetail />} />
                        <Route path="/AgentsaleDataDetail/:id" element={<AgentSaleDataDetail />} />
                        <Route path="/register/userData" element={<UserDataRegister/>} />
                        <Route path="AlertSystem" element={<AlertSystem />} />
                        <Route path="DeliveryMaster" element={<DeliveryMaster />} />
                        <Route path="DeliverySchedule" element={<DeliverySchedule />} />
                        <Route path="LoadCellManager" element={<LoadCellManager />} />
                        <Route path="HardWare" element={<HardWare />} />
                        <Route path="Scada" element={<ScadaPage />} />
                        <Route path="ProfilePictureUpload" element={<ProfilePictureUpload/>} />
                        <Route path="DdsAdmin" element={<DdsAdmin />} />
                        <Route path="TabletTokenAdmin" element={<TabletTokenAdmin />} />
                        <Route path="ImdRemoteControl" element={<ImdRemoteControl />} />
                        <Route path="ImdRemoteControl/:deviceId" element={<ImdDeviceDetail />} />
                        <Route path="PaymentCodeAdmin" element={<PaymentCodeAdmin />} />
                        <Route path="ShiftAdmin" element={<ShiftAdmin />} />
                        {LEGACY_REDIRECTS.map(r => <Route key={r.from} path={r.from} element={<RedirectKeepSearch to={r.to} />} />)}
                        <Route path="TaxInvoiceBulk" element={<TaxInvoiceBulk />} />
                        <Route path="PermissionAdmin" element={<PermissionAdmin />} />
                        <Route path="Cctv" element={<CctvViewer />} />
                        <Route path="debt-management" element={<DebtManagement />} />
                        <Route path="credit-customers" element={<CreditCustomers />} />
                        <Route path="cargo-registration" element={<CargoRegistrationAdmin />} />
                        <Route path="bag-ledger" element={<BagLedgerAccounting />} />
                        <Route path="accounting-daily-report" element={<AccountingDailyReport />} />
                        <Route path="bag-credit" element={<BagCredit />} />
                        <Route path="driver-daily-report" element={<DriverDailyReport />} />
                        <Route path="driver-assignment-list" element={<DriverAssignmentList />} />
                        <Route path="routine-customers" element={<RoutineCustomers />} />
                        <Route path="customer-purchase-behavior" element={<CustomerPurchaseBehavior />} />
                        {/* Add more routes here for other sections */}
                    </Route>
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
